import { asset } from "@/lib/asset";
const purchasePartners = [
    {
        "image": 0,
        "link": "https://t1-integration.ru/"
    },
    {
        "image": 1,
        "link": "https://ibs.ru/"
    },
    {
        "image": 2,
        "link": "https://otr.ru/"
    },
    {
        "image": 3,
        "link": "https://grkit.ru/"
    },
    {
        "image": 4,
        "link": "https://inform.gazprom.ru/"
    },
    {
        "image": 5,
        "link": "https://merlion.com/"
    },
    {
        "image": 6,
        "link": "https://q.center/"
    },
    {
        "image": 7,
        "link": "https://www.ramax.ru/"
    },
    {
        "image": 15,
        "link": "http://www.croc.ru/"
    },
    {
        "image": 16,
        "link": "http://rtk-it.ru/"
    },
    {
        "image": 17,
        "link": "https://service-apm.ru"
    },
   {
        "image": 19,
        "link": "https://itlanit.ru/"
    },
    {
        "image": 20,
        "link": "https://fortis.ru"
    },
    {
        "image": 21,
        "link": "https://rubytech.ru/"
    },
    {
        "image": 22,
        "link": "https://expert-apm.ru"
    },
    {
        "image": 23,
        "link": "https://astcapital.ru/"
    },
    {
        "image": 24,
        "link": "https://novardis.com/"
    },
    {
        "image": 25,
        "link": "https://www.rt-dc.ru"
    }
]

const PurchasePartner = (partner) => {
    return (<div className="flex flex-col items-center mx-auto my-[30px] lg:my-[60px] h-[180px] py-[10px]">
        <a href={`${partner.link}`} className="no-underline flex-1 flex items-center justify-center" target="_blank">
            <img loading="lazy"  src={asset(`/img/tex-partners/${partner.image}.png`)} className="object-contain max-w-[180px] max-h-[120px]" />
        </a>
        <a href={`${partner.link}`} className="text-underline mt-auto" target="_blank">
            Связаться
        </a>
    </div>)

}
export const PurchasePartners = () => {
    return (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 ">
            {purchasePartners.map((partner, k) => <PurchasePartner key={k} {...partner} />)}
        </div>
        )
}